__turbopack_context__.v({
  "item": "styles-module__hHqW5q__item",
  "itemLinks": "styles-module__hHqW5q__itemLinks",
  "itemShowMore": "styles-module__hHqW5q__itemShowMore",
  "itemText": "styles-module__hHqW5q__itemText",
  "itemTextActive": "styles-module__hHqW5q__itemTextActive",
  "reviews": "styles-module__hHqW5q__reviews",
  "showMore": "styles-module__hHqW5q__showMore",
});
